/** For `unit.dateRange('createdAt', { ...CREATED_AT_FILTER_TEXT })`. */
export const CREATED_AT_FILTER_TEXT = { title: 'Created at', description: 'Filter by creation date range' };
